import React, { useContext, useState } from 'react';
import Map from './Map';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { OrderDetails } from '../../App';
import './Shipment.css'

const Shipment = () => {
    const time = new Date(new Date().getTime() + (20 * 60 * 1000)).toLocaleTimeString().replace(/:\d+ /, ' ');
    const riders = ["Hamim", "Nahid", "Sumon", "Sabbir", "Sanjid", "Tamim"]
    for (let i = riders.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [riders[i], riders[j]] = [riders[j], riders[i]];
        }
    const [orderDetails, setOrderDetails] = useContext(OrderDetails)
    return (
        <div className="container d-flex">
            <div className="col-md-8 mt-5">
                <Map />
            </div>
            <div className="col-md-4 mt-5 shipment-card">
                <img src={require('../../images/bike.png').default} alt="" style={{width: '25%', margin: '20px 25px'}}/>
                <div style={{backgroundColor: 'white', padding: '20px 10px', borderRadius: '10px'}}>
                    <div className="d-flex">
                    <FiberManualRecordIcon color="secondary"/>
                    <p style={{marginLeft: '10px'}}>Your Location <br/> <small style={{color: 'gray'}}>{orderDetails.road}</small></p>
                    </div>
                    <div className="d-flex">
                    <FiberManualRecordIcon color="secondary"/>
                    <p style={{marginLeft: '10px'}}>Shop Address <br/> <small style={{color: 'gray'}}>Red Onion</small></p>
                    </div>
                </div>
                <h2 style={{marginTop: '20px'}}>{time}</h2>
                <p style={{color: 'gray'}}>Estimated delivery time</p>
                <div className="d-flex" style={{backgroundColor: 'white', padding: '10px', borderRadius: '10px'}}>
                    <img src={require('../../images/rider.png').default} alt="" style={{width: '100%'}} className="col-md-4"/>
                    <div className="col-md-8">
                        <h5>{riders[0]}</h5>
                        <small style={{color: 'gray'}}>Your rider</small>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Shipment;